import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import userReducers from "../reducers"

const updateUserDataAndSaveTokens = (state, action) => {
  userReducers.setData(state, action)
  userReducers.setTokens(state, action)
}

/* Play as a guest (owner, 2026-10-02): the server makes an ordinary account with a funny name, an
   address made from it on the game's domain and no password, and answers with the same
   `{refresh, access}` pair `/token/` returns, stored like any sign-in. From here the session is an
   ordinary one; `isGuest` is what the profile and the shop read. */
export const thunk = createAsyncThunk("user/guestLogin", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/auth/guest/", {}, { handlesOwnErrors: true })
    return {
      refreshToken: response.data.refresh,
      accessToken: response.data.access,
      isGuest: true,
    }
  } catch (error) {
    return rejectWithValue(error.response?.data || { detail: "Could not reach the server." })
  }
})

export const onSucceed = updateUserDataAndSaveTokens

const thunkObject = { thunk, onSucceed }
export default thunkObject
